import { useSuspenseQuery } from '@tanstack/react-query';
import { airportsIdGet } from '@/api/core/airports/airportsIdGet';

export const useAirport = (id: number) => useSuspenseQuery({
    queryKey: ['airport', id],
    queryFn: () => airportsIdGet(id).then(r => r.payload)
});
